module.exports = __webpack_public_path__ + "media/video1.a82ad3af.mp4";